/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignOut,
  faEllipsisV,
  faBarsStaggered,
  faXmarkCircle,
  faAddressBook,
} from "@fortawesome/free-solid-svg-icons";
import useSidebar from "./useSidebar";
import { navigateRoutes } from "../../_config/route";
import './Sidebar.scss';

// Reusable Component for Navigation Links
const NavLink = ({ icon, label, onClick, isActive }) => (
  <button
    onClick={onClick}
    className={`sidebar-link ${isActive ? "active-route" : ""}`}
  >
    <div className="icon">
      <FontAwesomeIcon icon={icon} />
    </div>
    <span>{label}</span>
  </button>
);

// Reusable Component for Drawer Links
const DrawerLink = ({ icon, label, onClick, isActive }) => (
  <button
    onClick={onClick}
    className={`drawer-link ${isActive ? "active-route" : ""}`}
  >
    <div className="icon">
      <FontAwesomeIcon icon={icon} />
    </div>
    <span>{label}</span>
  </button>
);

// Main Sidebar Component
export default (children) => {
  const {
    user,
    loading,
    isCollapsed,
    isDropdownOpen,
    dropdownRef,
    isDrawerOpen,

    location,
    toggleDrawer,
    onSignOutClick,
    toggleSidebar,
    handleToggleDropdown,
    handleNavigation,
  } = useSidebar();

  return (
    <div className={`sidebar ${isCollapsed ? "collapsed" : "expanded"}`}>
      {/* Company Section */}
      <div className="company centered">
        <span className="icon">
          Contact <b>Clues</b>
        </span>
        <button className="centered menu-bar" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={faBarsStaggered} />
        </button>
        <button className="centered drawer-bar" onClick={toggleDrawer}>
          <FontAwesomeIcon icon={faBarsStaggered} />
        </button>
      </div>

      {/* Inner Navigation Links */}
      <div className="inner drawer">
        <NavLink
          icon={faAddressBook}
          label="Contacts"
          onClick={() => handleNavigation(navigateRoutes.savedContacts)}
          isActive={location.pathname === navigateRoutes.savedContacts}
        />
      </div>

      {/* Bottom Section */}
      <div className="bottom drawer">
        <div className="user centered">
          <div className="user-img">
            <div className="bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center">
              {user?.full_name && user.full_name.charAt(0)}
            </div>
          </div>
          {!isCollapsed && (
            <>
              <div className="content flex-grow">
                <p className="mb-0">{user?.full_name}</p>
                <p className="mb-0 text-gray-500">{user?.email}</p>
              </div>
              {/* <div className="relative" ref={dropdownRef}>
                <button onClick={handleToggleDropdown} className="p-2">
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                {isDropdownOpen && (
                  <div
                    className="dropdown-menu"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabIndex="-1"
                  >
                    <div className="py-1">
                      <button
                        onClick={onSignOutClick}
                        className="dropdown-item"
                      >
                        {loading ? (
                          <div className="loader centered w-full"></div>
                        ) : (
                          <>
                            <FontAwesomeIcon
                              icon={faSignOut}
                              className="mr-2"
                            />
                            Logout
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div> */}
            </>
          )}
        </div>
      </div>

      {/* Drawer Slide-In */}
      {isDrawerOpen && (
        <div className={`drawer-slide ${isDrawerOpen ? "open" : ""}`}>
          <div className="close-drawer" onClick={toggleDrawer}>
            <FontAwesomeIcon icon={faXmarkCircle} />
          </div>
          <div className="inner">
            <DrawerLink
              icon={faAddressBook}
              label="Contacts"
              onClick={() => handleNavigation(navigateRoutes.savedContacts)}
              isActive={location.pathname === navigateRoutes.savedContacts}
            />
          </div>
          <div className="bottom">
            <div className="user centered">
              <div className="user-img">
                <div className="bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center">
                  {user?.full_name && user.full_name.charAt(0)}
                </div>
              </div>
              <div className="drawer-content flex-grow">
                <p className="mb-0">{user?.full_name}</p>
                <p className="mb-0 text-gray-500">{user?.email}</p>
              </div>
              <div className="relative" ref={dropdownRef}>
                <button onClick={handleToggleDropdown} className="p-2">
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                {isDropdownOpen && (
                  <div
                    className="dropdown-menu"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabIndex="-1"
                  >
                    <div className="py-1">
                      <button
                        onClick={onSignOutClick}
                        className="dropdown-item"
                      >
                        {loading ? (
                          <div className="loader centered w-full"></div>
                        ) : (
                          <>
                            <FontAwesomeIcon
                              icon={faSignOut}
                              className="mr-2"
                            />
                            Logout
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
